import { render, staticRenderFns } from "./pickup.vue?vue&type=template&id=282d074e"
import script from "./pickup.vue?vue&type=script&lang=js"
export * from "./pickup.vue?vue&type=script&lang=js"
import style0 from "./pickup.vue?vue&type=style&index=0&id=282d074e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports